import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Callout, ContentSection, Paragraph, Layout, Spinner, Modal } from "@vwfs-bronson/bronson-react";
import { trustedShopsQuestionnaireLink } from "./api";

export type CHIProps = {
  storefrontId: string;
}

export const CHI: FunctionComponent<CHIProps> = ({ storefrontId }) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [CHIUrl, setCHIUrl] = useState('')

  const buildCHILink = ({ text, url }) => (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  );

  const onSubmit = async () => {
    setIsSubmitting(true)
    try {
      const link = await trustedShopsQuestionnaireLink(storefrontId)
      setCHIUrl(link)
    } finally {
      setIsSubmitting(false)
    }
  }

  const onCHIConfirm = () => {
    window.open(CHIUrl, "_blank")
    setCHIUrl("")
  }

  return (
    <>
      {isSubmitting && <Spinner center fullPage />}
      <Modal
        shown={!!CHIUrl}
        title={t('chi:modal:title')}
        buttonConfirmText={t('chi:modal:button')}
        onConfirm={onCHIConfirm}
        hideCloseButton
      >
        {t('chi:modal:text')}
      </Modal>
      <ContentSection className="u-p-none">
        <Callout
          title={t(`chi:title`)}
        >
          <Paragraph>{t(`chi:text`)}</Paragraph>
          <Layout className="u-mt" center>
            <Layout.Item className="u-text-center">
              <Button type="button" onClick={onSubmit}>{t(`chi:button`)}</Button>
            </Layout.Item>
          </Layout>
        </Callout>
      </ContentSection>
      <ContentSection pageWrap className="u-pv-small">
        <Paragraph className="c-footnotes">
          {t("chi:legal:text1")}
        </Paragraph>
        <Paragraph className="c-footnotes u-mt-xsmall">
          {t("chi:legal:text2")}
          {buildCHILink(t("chi:legal:link1", { returnObjects: true }) as any)}{', '}
          {buildCHILink(t("chi:legal:link2", { returnObjects: true }) as any)}{', '}
          {buildCHILink(t("chi:legal:link3", { returnObjects: true }) as any)}{'.'}
        </Paragraph>
      </ContentSection>
    </>
  );
};
